<template>
  <v-autocomplete
    v-model="selectedCRMGroupUUID"
    :label="customLabel"
    :items="groupOptions"
    :menu-props="{ maxHeight: '400' }"
    @input.native="loadGroups()"
    :search-input.sync="groupSearch"
    color="primary"
    return-object
    clearable
    autocomplete="off"
    item-value="uuid"
    no-filter
    :rules="rules"
    :prepend-icon="prepandIcon"
    @click:clear="loadGroups(true, true)"
  >
    <template v-slot:item="{ item }">
      <span class="mr-2">
        {{ item.name }}
      </span>
      <span>
        <v-chip outlined>{{ getGroupType(item) }}</v-chip>
      </span>
    </template>
    <template v-slot:selection="{ item }">
      <span class="mr-2">
        {{ item.name }}
      </span>
      <span>
        <v-chip outlined>{{ getGroupType(item) }}</v-chip>
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import api from "@/utils/api";
import { mapGetters } from "vuex";

export default {
  props: {
    crmGroupUuid: {
      type: String,
      default: String,
    },
    initialData: {
      type: Object,
      default: Object,
    },
    customLabel: {
      type: String,
      default: function () {
        return this.$t("components.selectors.groupSelector.visibility");
      },
    },
    selectDefault: {
      type: Boolean,
      default: Boolean,
    },
    rules: {
      type: Array,
      default: Array,
    },
    hideSupergroup: {
      type: Boolean,
      default: false,
    },
    uuid: {
      type: String,
      default: String,
    },
    prepandIcon: {
      type: String,
      default: String,
    },
  },
  data: () => ({
    groupOptions: [],
    groupSearch: "",
    timeout: null,
  }),
  created() {
    if (this.initialData && Object.keys(this.initialData).length !== 0) {
      this.groupOptions.push(this.initialData);
      this.selectedCRMGroupUUID = this.initialData;
    }
    this.loadGroups(true);
  },

  computed: {
    ...mapGetters(["disableDealershipsWithoutAdvancedLicenceHandler"]),
    selectedCRMGroupUUID: {
      get: function () {
        return this.crmGroupUuid;
      },
      set: function (value) {
        if (typeof value === "undefined") {
          this.$emit("update:crm-group-uuid", null);
        } else {
          this.$emit("update:crm-group-uuid", value.uuid);
        }
      },
    },
  },
  methods: {
    getGroupType(item) {
      if (item.is_supergroup)
        return this.$t("components.selectors.groupSelector.organization");
      if (item.is_range)
        return this.$t("components.selectors.groupSelector.range");

      return this.$t("components.selectors.groupSelector.brand");
    },
    loadGroups(initalLoad = false, preventSelectDefault = false) {
      let fetchGroups = () => {
        return new Promise((resolve, reject) => {
          this.groupSearch = this.groupSearch ? this.groupSearch : "";

          let param = {
            visibility_item_uuid: this.uuid || null,
            exclude_supergroup: this.hideSupergroup,
            search: this.groupSearch,
          };

          if (param.visibility_item_uuid === null) {
            delete param.visibility_item_uuid;
          }

          api.groupsAutocomplete(param).then((resp) => {
            resp.data = this.disableDealershipsWithoutAdvancedLicenceHandler(
              resp.data
            );

            this.groupOptions = resp.data.filter((element) => {
              if (this.hideSupergroup && element.is_supergroup) {
                return false;
              }
              if (element.is_external_brand) {
                return false;
              }
              return true;
            });

            if (
              !this.hideSupergroup &&
              this.selectDefault &&
              !preventSelectDefault
            ) {
              const supergroup = resp.data.find(
                (element) => element.is_supergroup
              );
              if (supergroup != null) {
                this.selectedCRMGroupUUID = supergroup;
              }
            }

            if (this.groupOptions.length === 1) {
              this.selectedCRMGroupUUID = this.groupOptions[0];
            }
          });
        });
      };

      if (initalLoad) return fetchGroups();

      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        return fetchGroups();
      }, 300); // delay
    },
  },
};
</script>
